import { Set, Record } from 'immutable';

export interface RawPunchQuery {
  disciplines: string[];
  locations: string[];
  assignees: string[];
  groupAssignees: string[];
  priorities: string[];
  statuses: string[];
  createdBy: string[];
  unassigned: string[];
  overdue: number[];
  pages: string[]; // basically sheetversions
  sortField: string; // Make this an enum.
  sortDirection: 'ascending' | 'descending'; // make this an enum.
  search: string;
}

export interface PunchQueryData {
  disciplines: Set<string>;
  locations: Set<string>;
  assignees: Set<string>;
  groupAssignees: Set<string>;
  statuses: Set<string>;
  priorities: Set<string>;
  createdBy: Set<string>;
  unassigned: Set<string>;
  overdue: Set<number>;
  pages: Set<string>; // basically sheetversions
  sortField: string; // Make this an enum.
  sortDirection: 'ascending' | 'descending'; // make this an enum.
  search: string;
}

const defaultValues: PunchQueryData = {
  disciplines: Set<string>(),
  locations: Set<string>(),
  assignees: Set<string>(),
  groupAssignees: Set<string>(),
  statuses: Set<string>(),
  priorities: Set<string>(),
  createdBy: Set<string>(),
  unassigned: Set.of('disciplines', 'assignees', 'groupAssignees'),
  overdue: Set<number>(),
  pages: Set<string>(),
  sortField: 'id',
  sortDirection: 'descending',
  search: '',
};

export const PunchQueryFactory = Record(defaultValues, 'PunchQuery');

export class PunchQuery extends PunchQueryFactory {
  static deserialize(rawPunchQuery: RawPunchQuery): PunchQuery {
    return new PunchQuery({
      disciplines: Set(rawPunchQuery.disciplines),
      locations: Set(rawPunchQuery.locations),
      assignees: Set(rawPunchQuery.assignees),
      groupAssignees: Set(rawPunchQuery.groupAssignees),
      statuses: Set(rawPunchQuery.statuses),
      priorities: Set(rawPunchQuery.priorities),
      createdBy: Set(rawPunchQuery.createdBy),
      unassigned: Set(rawPunchQuery.unassigned),
      overdue: Set(rawPunchQuery.overdue),
      pages: Set(rawPunchQuery.pages),
      sortField: rawPunchQuery.sortField,
      sortDirection: rawPunchQuery.sortDirection,
      search: rawPunchQuery.search,
    });
  }

  serialize(): RawPunchQuery {
    return this.toJS();
  }

  searchApplied(): boolean {
    return this.search.length > 0;
  }

  filterApplied(): boolean {
    const {
      locations,
      assignees,
      groupAssignees,
      statuses,
      priorities,
      disciplines,
      unassigned,
      createdBy,
      overdue,
    } = this;

    return (
      locations.size > 0 ||
      assignees.size > 0 ||
      groupAssignees.size > 0 ||
      statuses.size > 0 ||
      priorities.size > 0 ||
      disciplines.size > 0 ||
      !unassigned.has('assignees') ||
      !unassigned.has('groupAssignees') ||
      createdBy.size > 0 ||
      overdue.size > 0
    );
  }
}
